import React from "react";

const Input = React.forwardRef((props, ref) => {

  const {
    id,
    type,
    name,
    placeholder,
    onChange,
    onBlur,
    onFocus,
    value,
    maxLength,
    autoComplete,
    dataAutomationId,
    autoFocus
  } = props;

  const isOTPVerificationModal = (typeOfModal) => {
    return typeOfModal==="OTP"
  }
  return (
    <input
      className="form-input__field"
      type={isOTPVerificationModal(type) ? "tel" : type}
      pattern={isOTPVerificationModal(type) ? "[0-9]*" : null}
      inputMode={isOTPVerificationModal(type) ? "numeric" : null}
      id={id}
      ref={ref}
      name={name}
      value={value || ""}
      maxLength={maxLength}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      autoComplete={autoComplete}
      data-automation-id={dataAutomationId}
      autoFocus={autoFocus} // eslint-disable-line
      onFocus={onFocus}
      data-pii
    />
  );
});

/* istanbul ignore next */
Input.defaultProps = {
  autoFocus: false
};

Input.displayName = "Input";

export default Input;
